import styled from "styled-components"
import { SectionText } from '../../../App.styled'

export const Section = styled.section`
  width: 100%;
  padding: 2rem 0;

  @media (min-width: 48em) {
    padding: 4rem 0;
  }

  @media (min-width: 62em) {
    padding: 8rem 0 6rem;
  }

  @media (min-width: 112em) {
    padding: 11rem 0 9rem;
  }
`

export const SectionContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;

  @media (min-width: 62em) {
    align-items: flex-start;
    flex-direction: row;
    flex-wrap: nowrap;
  }

  > img {
    max-width: 20rem;
    border-radius: 1.5rem;

    @media (min-width: 48em) {
      max-width: 26rem;
    }

    @media (min-width: 62em) {
      max-width: 100%;
    }
  }
`

export const SectionContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  max-width: 60rem;
  margin: 0 1rem;

  @media (min-width: 62em) {
    align-items: flex-start;
    margin-right: 8rem;
  }
`

export const ImageWithText = styled.div`
  display: flex;
  align-items: center;
  flex-wrap: nowrap;
  margin-bottom: 1.4rem;

  @media (min-width: 48em) {
    margin-bottom: 2.4rem;
  }

  @media (min-width: 62em) {
    margin-bottom: 3.4rem;
  }

  img {
    margin-right: 2.8rem;
    max-width: 7.4rem;
  }

  p {
    margin-bottom: 0;
    text-align: left;
    max-width: 41rem;
  }
`

export const BoldText = styled(SectionText)`
  font-weight: 600;
`
